export const border = {
  width10: "1px",
  width20: "2px",
  radius05: "2px",
  radius10: "4px",
  radius20: "6px",
  radius30: "8px",
  radius35: "10px",
  radius40: "12px",
  radius50: "16px"
};
//# sourceMappingURL=border.js.map